import React, {
  memo, useCallback, useId, useMemo,
} from 'react'

import { FiltersSidebar, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { addAdvancedFilter, removeAdvancedFilter } from 'Pods/SearchPage/Store/actions/moreFilters'
import { setContentSource } from 'Pods/SearchPage/Store/actions/qualityContent'
import { ADVANCED_FILTER, DEFAULT_STATE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import { CGT_STANDARD_SELECTED, contentSources, getCgtStandardConfig } from './constants'

const buildOptions = (translate, keyspace, items) => items.map((item) => ({
  value: item.value,
  label: item.icon
    ? (
        <span className="filter-wrapper__option--with-icon">
          <span>{translate(`search_page.filters.quality.${keyspace}.${item.labelKey}`)}</span>
          <Icon notSpaced svgComponent={item.icon} color="primary" size="small" />
        </span>
      )
    : translate(`search_page.filters.quality.${keyspace}.${item.labelKey}`),
}))

// The quality levels (Any / Basic / Premium / Pro) are hidden until there is data behind them; the
// store still carries `quality`, which nothing can change from the UI meanwhile.
function QualityContent() {
  const translate = useTranslate()
  const cgtStandardTooltipId = `cgt-standard-${useId().replace(/:/g, '')}`

  const contentSource = useSearchPageStore(state => state.contentSource ?? DEFAULT_STATE.contentSource)
  const hasCgtStandard = useSearchPageStore(
    state => (state.advancedFilters ?? EMPTY_ARRAY).includes(ADVANCED_FILTER.CGT_STANDARD_ONLY),
  )
  const trackFilterSelect = useTrackFilterSelect()

  const handleContentSourceFilterChange = useCallback((_, value) => {
    trackFilterSelect(FILTER_NAME.CONTENT_SOURCE, value)
    setContentSource(value)
  }, [trackFilterSelect])

  const handleCgtStandardChange = useCallback((_, value, isOn) => {
    if (isOn) {
      trackFilterSelect(FILTER_NAME.ADVANCED, value)
      addAdvancedFilter(value)
    } else {
      removeAdvancedFilter(value)
    }
  }, [trackFilterSelect])

  const contentSourceConfig = useMemo(() => [{
    label: translate('search_page.filters.quality.content_source_title'),
    filters: buildOptions(translate, 'content_source', contentSources),
  }], [translate])

  const cgtStandardConfig = useMemo(
    () => getCgtStandardConfig(translate, cgtStandardTooltipId),
    [translate, cgtStandardTooltipId],
  )

  const selectedContentSource = useMemo(() => [contentSource], [contentSource])

  return (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={contentSourceConfig}
        selectedFilters={selectedContentSource}
        onFiltersChange={handleContentSourceFilterChange}
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
        useRadio
      />
      <FiltersSidebar
        isCollapsible={false}
        filters={cgtStandardConfig}
        selectedFilters={hasCgtStandard ? CGT_STANDARD_SELECTED : EMPTY_ARRAY}
        onFiltersChange={handleCgtStandardChange}
        isControlled
        useNewCheckboxes
        hideLastDivider
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
    </>
  )
}

export default memo(QualityContent)
